module.exports = "/_next/static/images/business-planning-service-2-3ef205a000358fb81d558952b2ccacc6.webp";